"use client";
import {
  avatar_default
} from "./chunk-4EDCKTQT.mjs";
import {
  useAvatarGroup
} from "./chunk-YTVNLXJ4.mjs";
import {
  AvatarGroupProvider
} from "./chunk-PM5WBSHT.mjs";

// src/avatar-group.tsx
import { forwardRef } from "@nextui-org/system";
import { jsx, jsxs } from "react/jsx-runtime";
var AvatarGroup = forwardRef((props, ref) => {
  const {
    Component,
    clones,
    context,
    remainingCount,
    getAvatarGroupCountProps,
    getAvatarGroupProps,
    renderCount = (count) => /* @__PURE__ */ jsx(avatar_default, { ...getAvatarGroupCountProps(), name: `+${count}` })
  } = useAvatarGroup({
    ...props,
    ref
  });
  return /* @__PURE__ */ jsx(Component, { ...getAvatarGroupProps(), children: /* @__PURE__ */ jsxs(AvatarGroupProvider, { value: context, children: [
    clones,
    remainingCount > 0 && renderCount(remainingCount)
  ] }) });
});
AvatarGroup.displayName = "NextUI.AvatarGroup";
var avatar_group_default = AvatarGroup;

export {
  avatar_group_default
};
